const activeControllers = new Map<string, AbortController>();

/**
 * Builds an abort reason that still has `name === "AbortError"` (so existing
 * catch blocks keep treating it as a cancellation) but carries a message
 * naming who aborted. A bare `abort()` surfaces in Sentry as the anonymous
 * "signal is aborted without reason", which hides the call site.
 */
export const abortReason = (message: string) =>
  new DOMException(message, "AbortError");

export const getAbortSignalForKey = (key: string) => {
  // cancel previous request if exists
  const existingController = activeControllers.get(key);
  if (existingController) {
    existingController.abort(abortReason(`Superseded request: ${key}`));
  }
  const controller = new AbortController();
  activeControllers.set(key, controller);
  return controller.signal;
};

export const clearAbortController = (key: string) => {
  activeControllers.delete(key);
};
